var render = function render(){var _vm=this,_c=_vm._self._c;return _c('opinion-reviews-item',{class:{active: _vm.isActive, review__item: true},attrs:{"opinion":{
		..._vm.slide,
		pageLink: _vm.link
	}}})
}
var staticRenderFns = []

export { render, staticRenderFns }